/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, lifecycle, withHandlers } from 'recompose'
import { createSelector } from 'reselect'
import { connect } from 'react-redux'
import { withLocalization } from 'hocs/localization'
import { onGetPaymentHistory } from 'redux-app/actionCreators/users'
import { getPaymentHistory } from 'redux-app/selectors/user'
import { onShowError } from 'redux-app/modules/alerts'
import { isDateAfter } from 'shared/utils/date'
import { getReceipt } from 'api/client/actions/subscriptions'
import PaymentHistory from './PaymentHistory'

const getNormalizedPaymentHistory = createSelector(
  getPaymentHistory,
  paymentHistory => paymentHistory
    .sort((a, b) =>
      isDateAfter(a.received, b.received) ? -1 : 1,
    ))

export default compose(
  connect(
    state => ({
      items: getNormalizedPaymentHistory(state),
    }),
    {
      onGetPaymentHistory,
      getReceipt,
      onShowError,
    },
  ),
  withLocalization('profile.paymentHistory'),
  lifecycle<any, any>({
    componentWillMount () {
      this.props.onGetPaymentHistory()
        .then(() => {
          this.setState({
            loadProgress: 100,
          })
        })
        .catch(() => {
          this.setState({
            loadProgress: 100,
          })
        })
    },
  }),
  withHandlers({
    downloadReceipt: ({ onShowError, getReceipt }) => (id) => {

      getReceipt(id)
          .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.value.value]));
          const link = document.createElement('a');
          link.href = url;

          let clearFileName = response.value.fileName.split(/;(.+)/)[1].split(/=(.+)/)[1].split(";")[0].replaceAll("\"", '');

          link.setAttribute('download', clearFileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          onShowError(error)
        })
    },
  })
)(PaymentHistory)
